import {
  defaultLangFunction,
  localizeLoaderFactory,
} from '$core/helpers/ngx-translate';
import { ShellComponent } from '$core/shell/shell.component';
import { environment } from '$env/environment';
import { Location } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {
  LocalizeParser,
  LocalizeRouterModule,
  LocalizeRouterSettings,
} from 'localize-router';
import { ProtectedGuard } from './core/auth';
import { GLOBAL_REDIRECT_URL } from '$modules/pages/global-redirect/global-redirect.constants';

const routes: Routes = [
  {
    path: 'error',
    loadChildren: () =>
      import('./modules/error-pages/error-pages.module').then(
        (m) => m.ErrorPagesModule
      ),
  },
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: GLOBAL_REDIRECT_URL,
        loadChildren: () =>
          import('./modules/pages/global-redirect/global-redirect.module').then(
            (m) => m.GlobalRedirectModule
          ),
      }, // hack for page rerender
      {
        path: 'personal',
        loadChildren: () =>
          import('./modules/personal/personal.module').then(
            (m) => m.PersonalModule
          ),
        canActivate: [ProtectedGuard],
      },
      {
        path: 'cart',
        loadChildren: () =>
          import('./modules/cart/cart.module').then((m) => m.CartModule),
      },
      {
        path: 'example',
        loadChildren: () =>
          import('./modules/example-pages/example-pages.module').then(
            (m) => m.ExamplePagesModule
          ),
      },
      {
        path: 'clarify',
        loadChildren: () =>
          import('./modules/clarify-page/clarify-page.module').then(
            (m) => m.ClarifyPageModule
          ),
      },
      {
        path: 'prior-notice',
        loadChildren: () =>
          import('./modules/prior-notice/prior-notice.module').then(
            (m) => m.PriorNoticeModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/pages/pages.module').then((m) => m.PagesModule),
      },
    ],
  },
  { path: '**', redirectTo: 'error/404' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      preloadingStrategy: NoPreloading,
      useHash: false,
      scrollPositionRestoration: 'disabled', // handled by RouterScrollService
      anchorScrolling: 'disabled', // handled by RouterScrollService
      onSameUrlNavigation: 'ignore',
    }),
    LocalizeRouterModule.forRoot(routes, {
      parser: {
        provide: LocalizeParser,
        useFactory: localizeLoaderFactory,
        deps: [TranslateService, Location, LocalizeRouterSettings],
      },
      cacheName: environment.localStorageKeys.lang,
      alwaysSetPrefix: false,
      defaultLangFunction: defaultLangFunction,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
